/**
 * 叫号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 查询优惠券详情，同时校验优惠券在此订单中是否可用
export const couponDetail = (params) => {
  return req.get('/coupon/detail', params);
}
// 订单绑定优惠券
export const bindCoupon = (params) => {
  return req.post('/coupon/bindCoupon', params);
}
// 订单解绑优惠券
export const unbindCoupon = (params) => {
  return req.post('/coupon/unbindCoupon', params);
}
// 查询订单绑定的优惠券
export const getBingCoupon = (params) => {
  return req.get('/coupon/bind/get', params);
}
// 通过手机号查询会员优惠券可用列表和不可用列表
export const getCouponList = (params) => {
  return req.post('/coupon/list/phone', params);
}
//查询转介绍赠送的优惠券列表
export const getShareCoupon = (params) => {
  return req.get('/share/coupon/list', params);
}

//查询可参与的活动
export const getActivityList = (params) => {
  return req.post('/activity/newQuery', params);
}